export function getVideoDuration(file) {
  return new Promise((resolve, reject) => {
    const video = document.createElement("video");
    video.src = URL.createObjectURL(file);
    video.onloadedmetadata = function () {
      const duration = video.duration;
      resolve(parseInt(duration));
    };
    video.onerror = function (error) {
      reject(error);
    };
  });
}
const getExtension = (path = "") => {
  return path.split(".").pop().toLowerCase();
};
export function getVideoType(url) {
  const extension = getExtension(url);
  switch (extension) {
    case "mp4":
      return "video/mp4";
    case "webm":
      return "video/webm";
    case "ogg":
      return "video/ogg";
    case "mov":
      return "video/quicktime";
    case "m3u8":
      return "application/x-mpegURL";
    case "avi":
      return "video/x-msvideo";
    default:
      // If the extension is unknown, return null or an empty string
      return "";
  }
}
export function getVideoDurationByURL(url) {
  return new Promise((resolve, reject) => {
    const video = document.createElement("video");
    video.src = url;
    video.type = getVideoType(url);
    video.onloadedmetadata = function () {
      const duration = video.duration;
      resolve(parseInt(duration));
    };
    video.onerror = function (error) {
      reject(error);
    };
  });
}

export function convertToTime(seconds) {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;

  const minutesString = String(minutes).padStart(1, "0");
  const secondsString = String(remainingSeconds).padStart(2, "0");

  return `${minutesString}:${secondsString}`;
}

export const videoUrlRegex =
  /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/;

export const videoRegex = /\.(mp4|m3u8)$/;
